export default __webpack_public_path__ + "static/media/3233 cutlery side.a0c4d56b.png";